@if (cart$ | async; as cart) {
  <div class="sl-cart-summary box-order-summary offset-md-2">
    <div>
      <app-cart-coupon></app-cart-coupon>
    </div>

    <div>
      <app-order-details-list [cart]="cart"></app-order-details-list>
    </div>

    <div class="mb-7">
      <button
        appButton
        type="button"
        [attr.data-qa]="submitButtonId?.getButtonId()"
        [fullWidth]="true"
        *ngIf="activeStepIndex < lastStepIndex"
        (click)="goNext()"
      >
        <span appButtonText>{{
          'habaOrderSummary.btn.label' | cxTranslate: { context: activeStepIndex }
        }}</span>
      </button>
    </div>

    <div class="mb-4">
      <app-place-order
        [showTermsAndConditions]="false"
        *ngIf="activeStepIndex === lastStepIndex"
      ></app-place-order>
    </div>

    <div class="text-center mt-5 mb-0">
      <app-svg dimension="12px" iconName="Lock"></app-svg>
      <span class="ml-1 text-x_small">{{ 'habaOrderSummary.safeSSL' | cxTranslate }}</span>
    </div>
  </div>
  <app-applied-promotions-disclaimer
    class="pt-10 d-block d-md-none"
    [orderPromotions]="cart.appliedOrderPromotions"
    [productPromotions]="cart.appliedProductPromotions"
  ></app-applied-promotions-disclaimer>
}
